<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="topmenu" class="main-container">
    <!-- ============================================================== -->
    <!-- Topbar - style you can find in header.scss -->
    <!-- ============================================================== -->
    <mat-toolbar id="tnav" class="topbar topbar-themed telative">
        <!-- ============================================================== -->
        <!-- Logo - style you can find in header.scss -->
        <!-- ============================================================== -->
        <div id="topmenu" class="navbar-header" style="display: flex; align-items: center;">
            <a class="navbar-brand" href="index.html">
                <!-- Logo icon -->
                <!-- Logo text -->
                <span class="hide-xs">
                    <!-- dark Logo text -->
                    <img src="assets/images/logo-light-text.png" width="150px" alt="homepage" class="dark-logo">
                    <!-- Light Logo text -->
                    <img src="assets/images/logo-light-text.png" width="150px" class="light-logo" alt="homepage">
                </span>
            </a>
            @if (isDevelopment) {
            <span
                style="color: #ff9800; font-weight: bold; margin-left: 15px; font-size: 14px; white-space: nowrap;">DEVELOPMENT
                USE ONLY</span>
            }
        </div>
        <!-- ============================================================== -->
        <!-- sidebar toggle -->
        <!-- ============================================================== -->
        <button mat-button style="color:white;" (click)="toggleSidenav()" value="sidebarclosed">
            <mat-icon>menu</mat-icon>
        </button>
        <span style="flex: 1 1 auto;"></span>
        <!-- ============================================================== -->
        <!-- app header component - style you can find in header.scss / header.component.ts-->
        <!-- ============================================================== -->
        <app-header></app-header>
    </mat-toolbar>
    <!-- ============================================================== -->
    <!-- End Topbar - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-container id="topmenu" class="example-sidenav-container"
        [style.marginTop.px]="mobileQuery.matches ? 0 : 0" [ngClass]="{'minisidebar': minisidebar}">
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        <mat-sidenav #snav id="snav" class="pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0"
            [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" (open)="sidebarOpened = true"
            (close)="sidebarOpened = false">
            <app-sidebar></app-sidebar>
        </mat-sidenav>
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
        <mat-sidenav-content id="topmenu" class="page-wrapper">
            <div class="page-content">
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
    </mat-sidenav-container>
</div>